var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{attrs:{"to":_vm.getTo(),"active-class":_vm.aclass,"tag":_vm.rltag}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }